module.exports = __webpack_public_path__ + "static/fonts/SanFranciscoDisplayRegular.8b5ddd1.woff";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/SanFranciscoDisplayRegular.woff
// module id = PEWM
// module chunks = 1